module.exports = __webpack_public_path__ + "static/media/test.d52e947f.svg";